export const URL = {
    providercore_url : (window.location.hostname === 'labwise.medibuddy.in') ?  "https://providercore.medibuddy.in/" : "https://providernode-stage.medibuddy.in/",
    dev_url : "https://providercore.medibuddy.in/",
    s3_upload_image_url : "https://providercore.medibuddy.in/provider/Uploadfile",
    mb_wapi : "https://www.medibuddy.in/WAPI/",
    api_plus : "https://api-plus.medibuddy.in/",
    procheck : "https://ch-api-procheck.medibuddy.in/",
    cleverTap: "https://api.clevertap.com/1/upload",
    plus_api_prod : "https://plus-api-prod.medibuddy.in/"
}

export const USER = {
    access_token : localStorage.getItem("access_token") ?  localStorage.getItem("access_token") : '',
    user : localStorage.getItem('user_details') ? JSON.parse(localStorage.getItem("user_details")) : [],
   } 
   
export const STATUS_CODE_MAP = {
    "New Appointment Request":22,
    "Confirmed by Medical Center":23,
    "Confirmed by Ops":24,
    "Cancelled by Medical Center":26,
    "Rescheduled by Medical Center":29,
    "Rescheduled by Ops":30,
    "Rescheduled by User":31,
    "Attended":32,
    "Information Awaited":33,
    "Info submitted":37,
    "Not Attended":39,
    "Customer awaited at DC":40,
    "Cancelled":42,
    "QCApproved":48,
    "Partially Attended":116,
    "NotAttended by Others":118,
    "Cancelled by Insurer":119,
    "Closed by Insurer":120,
    "TU Completed":121,
    "TU Scheduled":122,
    "TU Information Awaited":123,
    "Fit with recommendation":126,
    "Fitness on Hold":127,
    "Temporary unfit":128,
    "System Confirmed":129,
    "Non Workable":130,
    "Digitization Pending":134, 
    "ReportProcessPending":140,
    "Rejected":146,
    "Branch Approval Pending":161,
    "Partial Report Uploaded":162,
}

export const ProvidersAffiliateOrders = [419652,407516]
export const ProviderAffiliateOrdersName = {
    419652: "Diagright",
    407516: "Lifecare",
    422069: "VBS",
}
export const SLA_FILTERS = {
    "New Appointments" :  "RequestCreationDate",
    "Confirmed Appointments" : "RequestFulfillmentDate",
    "Documents Pending" : "RequestModificationDate"
}

export const SLA_FILTER_TIME = {
    "RequestCreationDate" : 12 ,
    "RequestFulfillmentDate" : 4 ,
    "RequestModificationDate" : 24
}

export const CLEVER_TAP_EVENTS = {
    loginVisited:"Labwise Landing on Home Page",
    // loginAttempted:"Labwise Logging into portal",
    loginSuccess:"Labwise Login Sucess",
    loginFailed:"Labwise Login Failed",

    newApptVisited:"Labwise New Appointments Tab",
    // confirmBtnClick:"Labwise Clicking on Individual Confirm Button",
    // confirmPopupShown:"Labwise Individual Confirm popup shown",
    // confirmPopupBtnClick:"Labwise Individual Confirm popup click",
    confirmedApptSuccess:"Labwise Individual Confirm success",
    confirmedApptFailed:"Labwise Individual Confirm Failure",
    
    rejectApptSuccess:"Labwise Individual Reject success",

    bulkConfirmBtnClick:"Labwise Bulk Confirm Appointment clicked",
    // bulkConfirmPopupShown:"Labwise Bulk Appointment Confirm Popup Shown",
    // bulkConfirmPopupBtnClick:"Labwise Bulk Appointment Final Confirm clicked",
    bulkConfirmedApptSuccess:"Labwise Bulk Appointment Confirm Success",
    // bulkConfirmedApptFailed:"Labwise Bulk Appointment Confirm Failure",
    
    confirmedApptVisited:"Labwise Confirmed Appointments tab clicked",
    // markAttendedBtnClick:"Labwise Mark Attendance button clicked",
    // markAttendedPopupShown:"Labwise Mark Attended Popup shown",
    markAttendedPopupBtnClick:"Labwise MarkAttended on popup clicked",
    markAttendedSuccess:"Labwise Mark Attendance function success",
    // markAttendedFailed:"Labwise Mark Attendance function failure",

    // markNotAttendedBtnClick:"Labwise Mark Not Attendance button clicked",
    // markNotAttendedPopupShown:"Labwise Mark Not Attendance popup shown",
    // markNotAttendedPopupBtnClick:"Labwise Mark Not Attendance popup clicked",
    // markNotAttendedSuccess:"Labwise Not Mark Attendance function success",
    // markNotAttendedFailed:"Labwise Not Mark Attendance function failure",
    
    // bulkMarkAttendedBtnClick:"Labwise Bulk Attendance Click",
    // bulkMarkAttendedPopupShown:"Labwise Bulk Attendance Popup Shown",
    // bulkMarkAttendedPopupBtnClick:"Labwise Bulk Attendance Final Click",
    bulkMarkAttendedSuccess:"Labwise Mark Bulk Attendance Success",
    // bulkMarkAttendedFailed:"Labwise Bulk Attendance Failure",

    // attachDocIconClick:"Labwise Attach Document Click",
    // attachDocsPopupShown:"Labwise Submit Document Popup Shown",
    // attachReportsClick:"Labwise Attach Lab Reports Clicked",
    // uploadReportFailed:"Labwise Attach Lab Reports Failed",
    // attachBillsClick:"Labwise Attach Bills Clicked",
    // uploadBillsFailed:"Labwise Attach Bills failed",
    attachDocsFinalClick:"Labwise Documents Final Submit Click",
}

export const BRANCH_WHITELISTED_PROVIDERS = [50500,408076,380628,421965,42236,419384,42236,430765,430797]
